import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory as createHistory } from 'history';
const LOG_OUT_USER = 'app/LOG_OUT_USER';

const basename = process.env.REACT_APP_BASENAME || (() => {
	// This function checks to see if there's a <base> tag, and if there is, use the href from that as the basename.
	// If there isn't, then just use '/'.  This only kicks in if there's no REACT_APP_BASENAME in process.env, which
	// will be the case for stage/production builds.
	const basetag = document.getElementsByTagName( 'base' );
	if ( basetag.length ) {
		return basetag[0].href.replace( /^.*\/\/[^/]+/, '' );
	} else {
		return '/';
	}
})();

export const history = createHistory({
    basename
});

const initialState = {};
const enhancers = [];
const middleware = [
    thunk,
    routerMiddleware(history)
];

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers
);

const makeRootReducer = (reducers) => {
	return ( state, action ) => {
		// When logging out, we want to reset all non-anonymous pieces of the store ( so, not app and login )
		if ( LOG_OUT_USER === action.type ) {
			Object.keys( store.asyncReducers ).forEach( key => {
				if ( ['app','login'].indexOf( key ) === -1 ) {
					state[ key ] = undefined;
				}
			});
		}
		return combineReducers({
			routing: routerReducer,
			...reducers
		})(state,action);
	};
};

const store = createStore(
	makeRootReducer(),
    initialState,
    composedEnhancers
);
store.asyncReducers = {};

export const injectReducer = (key,reducer) => {
	store.asyncReducers[key] = reducer;
	store.replaceReducer( makeRootReducer(store.asyncReducers) );
};

export default store;



// WEBPACK FOOTER //
// ./src/services/ReduxStore.js